import { render, staticRenderFns } from "./MtUsersModal.vue?vue&type=template&id=28455afd&"
import script from "./MtUsersModal.vue?vue&type=script&lang=js&"
export * from "./MtUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports